import { render, staticRenderFns } from "./LoginFirst.vue?vue&type=template&id=64556d8b&"
import script from "./LoginFirst.vue?vue&type=script&lang=js&"
export * from "./LoginFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports